import axios from "axios";
import { ThumbUp, ThumbDownAlt } from "@mui/icons-material";
import { DOMAIN } from "config/config";
import { DATA_LINK } from "connectors";
import { store } from "static";
import { IconButton } from "@mui/material";
import { useState } from "react";
import { HStack } from "Components/Layouts";

interface IProps {
  cssp: string;
  lastItem: {
    _id: string;
  };
  feedback_by: string;
  defaultLike?: boolean | null;
  feedbackUrl: string;
  fetchData?: () => void;
  message_id: string;
}

const ZCFeedback = (props: IProps) => {
  const { cssp, lastItem, feedback_by, defaultLike, feedbackUrl, fetchData, message_id } = props;
  const [likeClicked, setLikeClicked] = useState(defaultLike === true);
  const [dislikeClicked, setDislikeClicked] = useState(defaultLike === false);
  let payloadOut = {
    JWT: store.user.JWT,
    data: {
      messageID: message_id,
      like: false,
      feedback_by: feedback_by,
    },
  };

  const onLike = async () => {
    if (!likeClicked) {
      payloadOut.data = {
        ...payloadOut.data,
        like: true,
      };
      await axios.post(feedbackUrl, payloadOut);
      setLikeClicked(true);
      setDislikeClicked(false);
      store.Alert(`You liked Answer`, "success");
      setTimeout(() => {
        fetchData && fetchData();
      }, 1000);
    }
  };

  const onDislike = async () => {
    if (!dislikeClicked) {
      payloadOut.data = {
        ...payloadOut.data,
        like: false,
      };
      await axios.post(feedbackUrl, payloadOut);
      setDislikeClicked(true);
      setLikeClicked(false);
      store.Alert(`You disliked Answer`, "success");
      setTimeout(() => {
        fetchData && fetchData();
      }, 1000);
    }
  };

  return (
    <HStack className={cssp + " msg-feedback"} sx={{ width: "60px" }}>
      <IconButton className="icon" onClick={onLike} sx={{ width: "10%", marginRight: "12px" }}>
        <ThumbUp sx={{ fontSize: 16, color: likeClicked ? "#3d6eff" : "grey" }} />
      </IconButton>
      <IconButton className="icon" onClick={onDislike} sx={{ width: "10%" }}>
        <ThumbDownAlt sx={{ fontSize: 16, color: dislikeClicked ? "red" : "grey" }} />
      </IconButton>
    </HStack>
  );
};

export default ZCFeedback;
